import { Dropdown, DropdownItem, DropdownList } from '@bnnvara/hub';
import PropTypes from 'prop-types';
import React from 'react';

import { NotificationDropdownItem } from './NotificationDropdownItem';

const NotificationsDropdown = ({
  notifications,
  setNotificationsOnRead,
  isLoading,
}) => {
  const hasNotifications = notifications.length > 0;
  const showHasNoNotificationsText = !isLoading && !hasNotifications;
  return (
    <Dropdown title="Jouw inbox" ariaLabel="Jouw persoonlijke notificaties">
      <DropdownList
        totalItems={hasNotifications ? notifications.length : 1}
        withScroll
        maxItemsVisible={5}
        /**
         * It is possible that the state is loading, and there are already notifications
         * For example, when receiving a notification from the websocket.
         */
        isLoading={isLoading && !hasNotifications}
      >
        {showHasNoNotificationsText && (
          <DropdownItem title="Je hebt nog geen notificaties" as="span" />
        )}

        {!showHasNoNotificationsText &&
          notifications.map((item) => {
            return (
              <NotificationDropdownItem
                key={item.slug}
                setNotificationsOnRead={setNotificationsOnRead}
                {...item}
              />
            );
          })}
      </DropdownList>
    </Dropdown>
  );
};

NotificationsDropdown.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape()),
  setNotificationsOnRead: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

NotificationsDropdown.defaultProps = {
  notifications: [],
  isLoading: true,
};

export { NotificationsDropdown };
